import {createRouter,createWebHistory} from 'vue-router'

const routes = [
    {
        path:'/login',
        name:'login',
        meta:{
            title:'登录',
        },
        component:()=>import('@/views/Login')
    },
];

const router = createRouter({
    history:createWebHistory('/'),
    routes,
});



export default router;
